// extracted by mini-css-extract-plugin
export default {"icon":"CharacterIcons_icon__fQeT3"};